module.exports = __webpack_public_path__ + "static/media/Rubik-Light.9e2c26ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/style/fonts/Rubik-Light/Rubik-Light.svg
// module id = 1301
// module chunks = 49